<section class="cz-site-filters-component" *ngIf="siteFilter$  | async as currentFilter">
  <section *ngIf="showContent">
    <p class="filters-title">
      <span class="filter-label" >{{'$site_filter_title' | translate}} <mat-icon class="link filters-info" matTooltip="{{'$filter_info_hover' | translate}}" matTooltipClass="filter-info-tooltip">info</mat-icon></span>
      <span class="clear-filters link" *ngIf="clearAllSiteFilters" (click)="clearAllFilters()" [innerHTML]="'$site_filter_reset_all_button' | translate"></span>
    </p>
    <!-- Date filter -->
    <cz-site-date-filter-menu *ngIf="currentFilter.filters"
        [filterDateData]="currentFilter?.dateFilter"
        (getFilterDates)="updateFilterDates($event)"></cz-site-date-filter-menu>
    <!-- User defined filters -->
    <cz-site-filter-menu *ngFor="let filter of currentFilter.filters" 
        [filterMenuData]="filter"
        (getUpdateFilterData)=updateFilterMenu($event)></cz-site-filter-menu>
    </section>
</section>
